module.exports = __webpack_public_path__ + "static/media/insta4.616444e2.jpg";